import UNAM from '../../../assets/images/sponsors/logo_unam.png';
import CICESE from '../../../assets/images/sponsors/logo_cicese.png';
import UABC from '../../../assets/images/sponsors/uabc.svg';
import CNYN from '../../../assets/images/sponsors/cnyn.jpeg';
import FIAD from '../../../assets/images/sponsors/fiad.svg';
import AMNN from '../../../assets/images/sponsors/AMNN.png';
import NANOTECH from '../../../assets/images/sponsors/NANOTECHCOLOR.svg';
import Ensenada from '../../../assets/images/sponsors/LogosXXVAyuntamiento-2.png';
import Anyhover from '../../../assets/images/sponsors/anyhover.png';

export const Sponsors = () => {
  return (
    <>
      <section className="snn-page-section snn-topics">
        <h2 className="snn-title">Participating institutions</h2>
        <div className="snn-topic-section snn-sponsors-section">
          <div>
            <img src={UNAM} alt="cic logo" />
          </div>
          <div>
            <img src={CNYN} alt="cic logo" />
          </div>
          <div>
            <img src={CICESE} alt="cic logo" />
          </div>
          <div>
            <img src={UABC} alt="cic logo" />
          </div>
        </div>
        <div className="snn-topic-section snn-sponsors-section">
          <div>
            <img className="uabc-logo" src={FIAD} alt="FIAD logo"/>
          </div>
          <div>
            <img className="uabc-logo" src={AMNN} alt="FIAD logo"/>
          </div>
          <div></div>
          <div></div>
        </div>
        <h2 className="snn-title">Sponsors</h2>
        <div className="snn-topic-section snn-sponsors-section">
          <div>
              <img src={Ensenada} alt="cnyn logo" />
          </div>
          <div>
              <img src={Anyhover} alt="cnyn logo" />
          </div>
            <div>
                <img src={NANOTECH} alt="cnyn logo" />
            </div>
          <div></div>
        </div>
      </section>
    </>
  );
};
